
export const GETDETAIL_VIDEODEMO_REQUEST = "GETDETAIL_VIDEODEMO_REQUEST";
export const GETDETAIL_VIDEODEMO_SUCCESS = "GETDETAIL_VIDEODEMO_SUCCESS";
export const GETDETAIL_VIDEODEMO_FAIL = "GETDETAIL_VIDEODEMO_FAIL";
